import { createContext, useState } from "react"

export const NotifContext = createContext()

export const NotifContextProvider = ({ children }) => {
  const [dataNotif, setDataNotif] = useState({})

  return (
    <NotifContext.Provider value={{ dataNotif, setDataNotif }}>
      {children}
    </NotifContext.Provider>
  )
}
